import { render, staticRenderFns } from "./Infos.vue?vue&type=template&id=b72d114e&scoped=true&"
import script from "./Infos.vue?vue&type=script&lang=js&"
export * from "./Infos.vue?vue&type=script&lang=js&"
import style0 from "./Infos.vue?vue&type=style&index=0&id=b72d114e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b72d114e",
  null
  
)

export default component.exports